// The barcode step: its top bar, and the footer with Type it, Upload photo and No barcode.


export function BarcodeBar({ bulkReturnUrl, cam, cancelTyping, checking, flipCamera, flipping, iconBtn, leaveScan, quick, quickMode, scanUi, toggleTorch, torchOn, typing }) {
  return (
    <>
      {scanUi || checking ? (
        <div className="cap-sbar">
          <button
            type="button"
            className={iconBtn}
            aria-label={typing ? "Cancel typing" : (quickMode && quick?.returnUrl) || bulkReturnUrl ? "Back to Cosmos" : "Close"}
            onClick={typing ? cancelTyping : leaveScan}
          >
            {quickMode || bulkReturnUrl ? (
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
            ) : (
              <span className="cap-sback" aria-hidden="true">&#8249;</span>
            )}
          </button>
          <div className="cap-stitle">
            <span>{quickMode ? "Quick scan" : "Bulk scan"}</span>
            <span>{checking ? "Checking the barcode" : "Scan the barcode"}</span>
          </div>
          <span className="cap-sright">
            {cam.canFlip && (cam.live || !scanUi) ? (
              <button type="button" className={iconBtn} aria-label="Flip camera" disabled={flipping} onClick={flipCamera}>
                <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><path d="M4 8h3l2-3h6l2 3h3v11H4z" /><path d="M9 13a3 3 0 0 1 5.2-2M15 13a3 3 0 0 1-5.2 2" /><path d="M14.5 9.5v1.6h-1.6M9.5 16.5v-1.6h1.6" /></svg>
              </button>
            ) : null}
            {cam.torchOk && (cam.live || !scanUi) ? (
              <button
                type="button"
                className={iconBtn + (torchOn ? " cap-sbtn--on" : "")}
                aria-label="Torch"
                aria-pressed={torchOn}
                disabled={flipping}
                onClick={toggleTorch}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" /></svg>
              </button>
            ) : null}
          </span>
        </div>
      ) : null}
    </>
  );
}

export function BarcodeFooter({ camState, flipTypeMode, noBarcode, openTyping, photoInRef, readPhoto, reading, saveError, scanUi, setTyped, submitTyped, typeAbc, typeInRef, typed, typing }) {
  return (
    <>
      {scanUi ? (
        <div className={"cap-scanbot" + (typing ? " cap-scanbot--typing" : "")}>
          {saveError ? (
            <p className="cap-error" role="alert">
              {saveError}
            </p>
          ) : null}
          {typing ? null : camState === "none" ? <span className="cap-scanbot-none">No camera on this device</span> : <span className="cap-scanbot-lead">Can&rsquo;t scan it?</span>}
          <input
            ref={photoInRef}
            type="file"
            accept="image/*"
            className="cap-file"
            tabIndex={-1}
            aria-hidden="true"
            onChange={readPhoto}
          />
          {typing ? (
            <form
              className="cap-typeform cap-swap"
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                submitTyped();
              }}
            >
              <span className="cap-typewrap">
                <input
                  className="cap-typein"
                  ref={typeInRef}
                  value={typed}
                  onChange={(e) => setTyped(e.target.value)}
                  placeholder="Type the barcode"
                  aria-label="Barcode"
                  type="text"
                  inputMode={typeAbc ? "text" : "numeric"}
                  pattern={typeAbc ? undefined : "[0-9]*"}
                  autoComplete="off"
                  autoCapitalize="characters"
                  autoCorrect="off"
                  spellCheck={false}
                  enterKeyHint="go"
                />
                <button
                  type="button"
                  className="cap-typemode"
                  aria-label={typeAbc ? "Number keypad" : "Letter keyboard"}
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={flipTypeMode}
                >
                  {typeAbc ? "123" : "ABC"}
                </button>
              </span>
              <button type="submit" className="cap-typego" aria-label="Look up" disabled={!typed.trim()}>
                <svg width="20" height="20" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
              </button>
            </form>
          ) : (
            <div className="cap-sopts cap-swap">
              <button type="button" className="cap-sopt" onClick={openTyping}>
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><rect x="2.5" y="6" width="19" height="12" rx="2.5" /><path d="M6.5 10h.01M10 10h.01M13.5 10h.01M17 10h.01M8 14h8" /></svg>
                </span>
                Type it
              </button>
              <button
                type="button"
                className="cap-sopt"
                disabled={reading}
                onClick={() => photoInRef.current?.click()}
              >
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><path d="M12 15V3M7 8l5-5 5 5" /><path d="M4 14v4a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-4" /></svg>
                </span>
                {reading ? "Reading..." : "Upload photo"}
              </button>
              <button type="button" className="cap-sopt" onClick={noBarcode}>
                <span>
                  <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" aria-hidden="true"><path d="M5 6v12M8 6v12M11 6v8M14 6v12M17 6v6M20 6v12" /><path d="M3 21L21 3" /></svg>
                </span>
                No barcode
              </button>
            </div>
          )}
        </div>
      ) : null}
    </>
  );
}
